/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../../utils/logger';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ReactFlow, SmoothStepEdge, BezierEdge, StraightEdge } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import apiExports from '../../api/api';
import ArrowBoxNode from '../../all-node/process-map-nodes/ArrowBoxNode';
import PentagonNode from '../../all-node/process-map-nodes/PentagonNode';
const MiniMapPreview = ({ processId, userId, processLanguageId }) => {
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);

  const memoizedNodeTypes = useMemo(
    () => ({
      progressArrow: (props) => <ArrowBoxNode {...props} editable={false} />,
      pentagon: (props) => <PentagonNode {...props} editable={false} />,
    }),
    []
  );

  const memoizedEdgeTypes = useMemo(
    () => ({
      smoothstep: SmoothStepEdge,
      bezier: BezierEdge,
      straight: StraightEdge,
    }),
    []
  );
  const fetchNodes = useCallback(async () => {
    try {
      const levelParam = 'Level0';

      // Check if process has already been published at Level0
      let isPublished = false;
      try {
        const publishCheck = await apiExports.checkPublishRecord(levelParam, processId);
        isPublished = !!publishCheck?.status;
      } catch (err) {
        logger.warn('Error checking publish status for preview:', err);
      }

      let data;
      if (isPublished) {
        // If already published, ALWAYS show published nodes
        data = await apiExports.getPublishedNodes(
          levelParam,
          parseInt(userId),
          processId,
          null,
          processLanguageId
        );
      } else {
        // If not published yet, show draft nodes preview
        data = await apiExports.getNodes(
          levelParam,
          parseInt(userId),
          processId,
          null,
          processLanguageId
        );
      }

      const rawNodes = data?.nodes || [];
      const parsedNodes = rawNodes
        .filter((node) => node && node.type !== 'StickyNote')
        .map((node) => {
          try {
            const parsedData =
              typeof node.data === 'string' ? JSON.parse(node.data) : node.data || {};
            const parsedPosition =
              typeof node.position === 'string'
                ? JSON.parse(node.position)
                : node.position || { x: 0, y: 0 };
            const parsedMeasured = node.measured
              ? typeof node.measured === 'string'
                ? JSON.parse(node.measured)
                : node.measured
              : null;

            return {
              ...node,
              id: node.node_id,
              type: node.type,
              position: parsedPosition,
              data: parsedData,
              style: parsedMeasured
                ? {
                    width: parsedMeasured.width,
                    height: parsedMeasured.height,
                  }
                : undefined,
              draggable: false,
            };
          } catch (e) {
            logger.error('Error parsing node in preview:', e, node);
            return null;
          }
        })
        .filter(Boolean);

      setNodes(parsedNodes);
      setEdges([]); // optional
    } catch (err) {
      logger.error('Error loading level 0 nodes:', err);
    }
  }, [processId, userId, processLanguageId]);

  useEffect(() => {
    if (processId && userId) {
      fetchNodes();
    }
  }, [fetchNodes, processId, userId]);
  if (!nodes.length) return <div style={{ height: 200 }}> </div>;

  return (
    <div style={{ width: '100%' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        nodeTypes={memoizedNodeTypes}
        edgeTypes={memoizedEdgeTypes}
        proOptions={{ hideAttribution: true }}
      ></ReactFlow>
    </div>
  );
};

export default MiniMapPreview;
